import { buildUrl } from 'src/_helpers/buildUrl'
import { fetchApi } from 'src/_helpers/client/fetchApi'
const API_BASE = process.env.NEXT_PUBLIC_API_ENTRYPOINT || ''
const PATH = '/api/open/journals'

async function getByUuid(uuid) {
  if (!uuid) {
    return null
  }

  const url = `${PATH}/${uuid}`

  return await fetchApi(
    url,
    'GET',
    { accept: 'application/json' },
    { next: { tags: [`journal_articles:${uuid}`] } },
  ).then(
    (response) => response,
    (error) => {
      if (error?.status === 404) {
        return null
      }

      throw new Error(`Failed to fetch journal: ${url}`)
    },
  )
}

async function searchJournals(filters = {}) {
  const {
    includeFacets = false,
    facetScopePublisher,
    issn,
    publishers,
    disciplines,
    fields,
    publicationLanguages,
    licenseModels,
    openAccess,
    orderBy = 'title',
    order = 'asc',
    lang = 'pl',
    page = 1,
    perPage = 30,
  } = filters

  const params = { includeFacets, ...(facetScopePublisher ? { facetScopePublisher } : {}) }

  if (issn !== undefined) params.issn = issn
  if (openAccess !== undefined) params.openAccess = openAccess
  if (orderBy) params.orderBy = orderBy
  if (order) params.order = order
  if (lang) params.lang = lang
  if (page) params.page = page
  if (perPage) params.perPage = perPage

  // Add array filters
  if (Array.isArray(publishers) && publishers.length > 0) {
    publishers.forEach((id, index) => {
      params[`publishers[${index}]`] = id
    })
  }
  if (Array.isArray(disciplines) && disciplines.length > 0) {
    disciplines.forEach((id, index) => {
      params[`disciplines[${index}]`] = id
    })
  }
  if (Array.isArray(fields) && fields.length > 0) {
    fields.forEach((id, index) => {
      params[`fields[${index}]`] = id
    })
  }
  if (Array.isArray(publicationLanguages) && publicationLanguages.length > 0) {
    publicationLanguages.forEach((id, index) => {
      params[`publicationLanguages[${index}]`] = id
    })
  }
  if (Array.isArray(licenseModels) && licenseModels.length > 0) {
    licenseModels.forEach((id, index) => {
      params[`licenseModels[${index}]`] = id
    })
  }

  const url = buildUrl(`${API_BASE}${PATH}/search`, params)

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      Accept: 'application/ld+json',
    },
  })

  if (!response.ok) {
    throw new Error(`Failed to search journals: ${response.statusText}`)
  }

  return await response.json()
}
export const journalService = {
  getByUuid,
  searchJournals,
}
